const Envelope = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <path
      fill="#222"
      d="M25.5 8h-18C6.7 8 6 8.7 6 9.5v13c0 .8.7 1.5 1.5 1.5h18c.8 0 1.5-.7 1.5-1.5v-13c0-.8-.7-1.5-1.5-1.5Zm.5 14.5c0 .3-.2.5-.5.5h-18c-.3 0-.5-.2-.5-.5V9.6l8.7 6.3c.1.1.2.1.3.1.1 0 .2 0 .3-.1l7.5-5.1c.2-.2.3-.5.1-.7-.2-.2-.5-.3-.7-.1L16 14.9 7.8 9h17.7c.3 0 .5.2.5.5v13Z"
    />
  </svg>
)
export { Envelope }
